// External libraries
import gql from 'graphql-tag';

// TODO: GenericAddress fields deprecated in favor of portable addresses
// see: https://github.paypal.com/Checkout-R/xobuyernodeserv/pull/2746
/* eslint graphql/no-deprecated-fields: off */

export const CREATE_BANK_ACCOUNT_CANDIDATE_MUTATION = gql`
  mutation CreateBankAccountCandidate(
    $bank: BankAccountInput!
    $beneficiary: BankAccountBeneficiaryInput
    $billingAddress: AddressInput
    $countryCode: CountryCodes!
  ) {
    addBankCandidate(
      bank: $bank
      beneficiary: $beneficiary
      billingAddress: $billingAddress
      countryCode: $countryCode
    ) {
      accountNumber
      accountNumberShort
      bankIdentifierCode
      beneficiaries {
        fullName
      }
      billingAddress {
        city
        fullAddress
      }
      creditor {
        address {
          fullAddress
        }
        id
        name
      }
      currencyCode
      id
      issuer {
        branchLocation
        city
        country
        name
      }
      nickname
      routingNumber
      type
    }
  }
`;
